import { useMemo } from 'react';

import { Group, Text, ThemeIcon, centsToDollar } from 'ui';
import { IconRewardsSimple } from 'ui/Icons';

type SavedWithRewardsProps = {
  rewardsUsedAmount?: number;
};

const SavedWithRewards = ({ rewardsUsedAmount }: SavedWithRewardsProps) => {
  const rewardsUsedAmountFormatted = useMemo(() => {
    return centsToDollar(rewardsUsedAmount);
  }, [rewardsUsedAmount]);

  if (!rewardsUsedAmount) {
    return null;
  }

  return (
    <Group gap="xs" align="center" justify="center">
      <ThemeIcon size="md" radius="sm" variant="transparent" color="mint.7">
        <IconRewardsSimple size={24} />
      </ThemeIcon>
      <Text fz="12px">
        You saved{' '}
        <Text span fw={600} fz="12px">
          {rewardsUsedAmountFormatted}
        </Text>{' '}
        with{' '}
        <Text span fw={600} fz="12px">
          Rewards!
        </Text>
      </Text>
    </Group>
  );
};

export { SavedWithRewards };
